export default () => ({
    filters: {
        // Месяц
        month: false,

        // Жанры
        event_types: [],

        // Возраст
        age_limits: [],

        // Премьера
        premiere: false,

        // Пушкинская карта
        pushkin_card: false,

        // Есть билеты
        in_stock: false,

        // Скидка
        sale: false,

        // Гастроли
        touring: false,
    },
    default_filters: {
        // Месяц
        month: false,

        // Жанры
        event_types: [],

        // Возраст
        age_limits: [],

        // Премьера
        premiere: false,

        // Пушкинская карта
        pushkin_card: false,

        // Есть билеты
        in_stock: false,

        // Скидка
        sale: false,

        // Гастроли
        touring: false,
    },
    state: {
        // Флаг инициализации компонента
        is_initialized: false,

        // Флаг изменения активной записи истории
        from_popstate: false,

        // Контейнер для контента с пагинацией
        paged_content_element: null,

        // Значение сдвига полосы прокрутки
        loading_scroll_top: 0,

        // Язык
        lang: 'ru',

        // Номер текущей страницы
        page: 1,

        // Флаг размещения на главной странице
        is_front_page: false,

        // Флаг загрузки
        is_loading: false,

        // Флаг необходимости повторной загрузки (поменялись фильтры)
        is_need_to_load: false,

        // Флаг наличия следующей страницы
        has_next_page: false,

        // Последний месяц загруженной страницы (для разделителя смены месяца)
        last_event_month: null,

        // URL следующей страницы для ссылки (могут открыть в новой вкладке)
        next_page_url: '',

        // Базовый URL запроса, добавляется перед маршрутом
        base_url: '',

        // Маршрут запроса
        route: '',

        // Развернуть фильтры на мобильном экране?
        show_filters: false,

        // Дата события к которому необходимо перейти (нажатие из календаря)
        navigate_to_date: false,

        // Флаг ожидания перехода к событию из календаря
        is_navigate_to_date_pending: false,

        // Информация для фильтров о доступных событиях
        available_events: [],

        // Календарь
        calendar: {
            // Раскрыть календарь?
            is_open: false,

            // Начальный месяц (дата)
            initial_month: null,

            // Активный месяц (дата)
            active_month: null,

            today: null,

            // Массив месяцев (для вкладок календаря)
            months: [],

            // Дни активного месяца (для вывода в фильтре)
            days_of_month: [],
        },
    },

    // Фильтр «Возраст»
    age_limit_filter: {
        options: [],
        active_options: [],
        filter_options: [],
    },

    // Фильтр «Жанр»
    event_type_filter: {
        options: [],
        active_options: [],
        filter_options: [],
    },

    _abortController: null,

    init() {
        // noinspection JSUnresolvedReference
        const { state: stateData, filters: filtersData } = JSON.parse(this.$root.getAttribute('data-state'));

        this.initState(stateData);
        Object.assign(this.filters, filtersData);
        this.initFilters(stateData.age_limit_options, stateData.event_type_options);
        this.initCalendar(stateData.calendar);
        this.handlePopState();

        if (!this.state.is_front_page) {
            this.handleLocationHash();
        }

        // Таймаут для инициализации фильтров
        setTimeout(() => {
            this.loadPage(1);
            this.state.is_initialized = true;
        }, 100);
    },

    initState(stateData) {
        // noinspection JSUnresolvedReference
        this.state.paged_content_element = this.$root.querySelector('#paged_content');

        if (!this.state.paged_content_element) {
            throw new Error('Не удалось найти контейнер для контента с пагинацией');
        }

        this.state.lang             = stateData.lang;
        this.state.page             = stateData.page;
        this.state.is_front_page    = stateData.is_front_page;
        this.state.has_next_page    = stateData.has_next_page;
        this.state.next_page_url    = stateData.next_page_url;
        this.state.base_url         = stateData.base_url.replace(/\/$/, '');
        this.state.route            = stateData.route.replace(/\/$/, '');
        this.state.available_events = stateData.available_events;
    },

    initCalendar(calendarData) {
        const initial_month_Ymd = calendarData.initial_month;

        this.state.calendar.initial_month = new Date(initial_month_Ymd);
        this.state.calendar.active_month  = calendarData.active_month;
        this.state.calendar.today         = new Date(calendarData.today);

        let monthsYmd = Array.from(new Set(this.state.available_events
            .map(event => event.date.replace(/-\d{2}$/, '-01'))));

        if (!monthsYmd.includes(initial_month_Ymd)) {
            monthsYmd.unshift(initial_month_Ymd);
        }

        let months = monthsYmd.map(monthYmd => new Date(monthYmd))
            .sort((a, b) => a - b);

        months.forEach((month) => {
            this.state.calendar.months.push(month.toISOString().slice(0, 10));
        });

        this.updateMonthFilter();

        // noinspection JSUnresolvedReference
        this.$watch('filters.month', (value) => {
            if (!value) {
                value = this.state.calendar.initial_month.toISOString().split('T')[0];
            }

            this.state.calendar.active_month = value;
        });

        // noinspection JSUnresolvedReference
        this.$watch('state.calendar.active_month', () => {
            this.updateMonthFilter();
            this.updateDaysOfMonth();
        });

        Alpine.nextTick().then(() => {
            this.updateDaysOfMonth();
        });
    },

    updateMonthFilter() {
        if (this.state.calendar.active_month === this.state.calendar.initial_month) {
            this.filters.month = false;
        } else {
            this.filters.month = this.state.calendar.active_month;
        }

        Alpine.store('global').filters.event_month = this.state.calendar.active_month;
    },

    updateDaysOfMonth() {
        this.state.calendar.days_of_month.length = 0;

        let date = new Date(this.state.calendar.active_month);

        date.setDate(1);

        const firstDayOfMonthWeekday = date.getDay(); // (0..6, где 0 — Воскресенье)

        const firstDayOfMonthWeekdayAdjusted = firstDayOfMonthWeekday === 0
            ? 6
            : firstDayOfMonthWeekday - 1;

        for (let i = 0; i < firstDayOfMonthWeekdayAdjusted; i++) {
            this.state.calendar.days_of_month.push({
                value: '',
                date: null,
                hasEvents: false,
                isPrevMonth: true,
            });
        }

        const monthDateObj = new Date(this.state.calendar.active_month);

        const year = monthDateObj.getFullYear();

        const monthIndex = monthDateObj.getMonth();

        const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

        for (let i = 0; i < daysInMonth; i++) {
            let dayDate = new Date(date);

            dayDate.setDate(i + 1);

            this.state.calendar.days_of_month.push({
                value: i + 1,
                date: dayDate,
                hasEvents: false,
                isPrevMonth: false,
            });
        }
    },

    initFilters(age_limit_options, event_type_options) {
        // Инициализация фильтра «Возраст»
        this.initAgeLimitFilter(age_limit_options);

        // Инициализация фильтра «Жанр»
        this.initEventTypeFilter(event_type_options);

        // Загрузка при изменении фильтров
        const debouncedLoadPage = Alpine.debounce(this.loadPage.bind(this), 500);

        // noinspection JSUnresolvedReference
        this.$watch('filters', () => {

            // Активные типы событий в шапке
            Alpine.store('global').filters.event_types = this.filters.event_types;
        });

        Alpine.nextTick().then(() => {
            Alpine.nextTick().then(() => {
                // noinspection JSUnresolvedReference,JSUnusedLocalSymbols
                this.$watch('filters', (value, oldValue) => {
                    if (this.state.is_front_page) {
                        return;
                    }

                    this.state.is_need_to_load = true;

                    // history

                    let searchParamsData = this.getSearchParamsData()

                    const historySearchParams = new URLSearchParams(searchParamsData).toString().replace(/%2C/g, ',');

                    if (!this.state.from_popstate) {
                        const data = JSON.parse(JSON.stringify(this.filters));
                        const url  = this.state.base_url + this.state.route + '?' + historySearchParams;
                        history.pushState(data, window.title, url);
                    }

                    debouncedLoadPage(1, this.state.from_popstate, false);
                })
            });
        });
    },

    getSearchParamsData() {
        let data = {}

        // Месяц
        if (this.filters.month) {
            data.month = this.filters.month;
        }

        // Тип события
        const event_types_join = this.filters.event_types.join(',');

        if (event_types_join.length) {
            data.type = event_types_join;
        }

        // Возраст
        const age_limits_join = this.filters.age_limits.join(',');

        if (age_limits_join.length) {
            data.age_limit = age_limits_join;
        }

        // Премьера
        if (this.filters.premiere) {
            data.premiere = '1';
        }

        // Пушкинская карта
        if (this.filters.pushkin_card) {
            data.pc = '1';
        }

        // Есть билеты
        if (this.filters.in_stock) {
            data.in_stock = '1';
        }

        // Скидка
        if (this.filters.sale) {
            data.sale = '1';
        }

        // Гастроли
        if (this.filters.touring) {
            data.touring = '1';
        }

        // На главной странице?
        if (this.state.is_front_page) {
            data.front = 1;
        }

        return data;
    },

    handlePopState() {
        // Обработчик события изменения URL
        window.addEventListener('popstate', (event) => {
            this.state.from_popstate = true;
            this.state.page          = 1;

            for (let key in this.filters) {
                if (this.default_filters.hasOwnProperty(key)) {
                    this.filters[key] = this.default_filters[key];
                    console.log(`The ${key} filter sets to ${this.default_filters[key]} (default) on popstate`);
                }
            }

            if (event.state) {
                for (let key in this.filters) {
                    if (event.state.hasOwnProperty(key)) {
                        this.filters[key] = event.state[key];
                        console.log(`The ${key} filter sets to ${event.state[key]} on popstate event`);
                    }
                }
            }
        });
    },

    handleLocationHash() {
        const hash = window.location.hash ?? '';

        // 11 — длина строки с символом решетки и датой `#yyyy-mm-dd`
        if (hash.length !== 11) {
            return;
        }

        this.state.navigate_to_date = hash.replace('#', '');
        console.debug('navigate to date hash value', this.state.navigate_to_date);

        history.replaceState(null, null, window.location.href.split('#')[0]);
        this.state.is_navigate_to_date_pending = true;
        this.navigateToEventWithDateAttempt();
    },

    /**
     * Загрузка страницы пагинации
     * @param page
     * @param from_popstate
     * @param focus
     */
    loadPage(page, from_popstate = false, focus = true) {
        console.debug('[archive-event] Загрузка страницы ' + page, from_popstate);

        // Сброс значения popstate
        this.state.from_popstate = false;

        // Сброс флага необходимости загрузки
        this.state.is_need_to_load = false;

        if (this.state.is_loading) {
            if (page > 1) {
                this.state.is_need_to_load = true;
                console.debug('[archive-event] Загрузка страницы уже выполняется');
                return;
            }
            this._abortController?.abort();
        }

        if (page > this.state.page && !this.state.has_next_page) {
            console.debug('[archive-event] Нет такой страницы');
            return;
        }

        this.state.is_loading = true;
        this.state.page       = page;

        let routePaged = this.state.route;

        if (this.state.page > 1) {
            routePaged += '/page/' + this.state.page;
        } else {
            this.clearPagedContainer();
        }

        if (focus) {
            this.focusLastItem();
        }

        // Сохранить положение прокрутки
        if (!this.state.is_navigate_to_date_pending) {
            this.state.loading_scroll_top = window.scrollY;
        }

        // Восстановить положение прокрутки
        if (!this.state.is_navigate_to_date_pending) {
            window.scrollTo(0, this.state.loading_scroll_top);
        }

        // Параметры запроса
        let searchParamsData = this.getSearchParamsData()

        searchParamsData.json = 1;

        // Последний месяц предыдущей страницы (для разделителя смены месяца)
        // Не добавляется в URL — только в AJAX-запрос
        if (this.state.last_event_month && page > 1) {
            searchParamsData.prev_month = this.state.last_event_month;
        }

        console.log('Параметры запроса', searchParamsData);

        const controller = new AbortController();
        this._abortController = controller;

        // noinspection JSCheckFunctionSignatures
        axios.get(routePaged, {
            baseURL: this.state.base_url,
            params: searchParamsData,
            signal: controller.signal,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then(response => {
            this.state.page = response.data.page ?? 1;

            if (this.state.page === 1) {
                this.clearPagedContainer();
            }

            this.state.paged_content_element.insertAdjacentHTML('beforeend', response.data.content ?? '');
            this.state.has_next_page    = response.data.has_next_page ?? false;
            this.state.next_page_url    = response.data.next_page_url ?? '';
            this.state.last_event_month = response.data.last_month ?? null;
        }).catch(error => {
            if (axios.isCancel(error)) return;
            console.error(error);
        }).finally(() => {
            if (this._abortController !== controller) return;

            this.state.is_loading = false;

            // Если во время загрузки фильтры поменялись
            if (this.state.is_need_to_load) {
                this.state.is_need_to_load = false;
                this.loadPage(1, false, false);
                return;
            }

            // Загружаем страницы пока есть страницы и не появится следующий месяц
            if (this.state.has_next_page && !this.state.is_front_page) {
                this.loadNextPageUntilNextMonth();
            }

            // Попытка прокрутки до карточки события, если был клик по дате в календаре
            this.navigateToEventWithDateAttempt();

            // Сканирование кнопок Яндекс Билеты
            if (typeof window['ticketDealer'] !== 'undefined') {
                if (typeof window['ticketDealer'].scan === 'function') {
                    window['ticketDealer'].scan();
                    console.debug('ticketDealer.scan');
                }
            }
        });
    },

    /**
     * Очистка списка элементов архива
     */
    clearPagedContainer() {
        console.debug('[archive-event] очистка списка элементов');

        this.state.last_event_month             = null;
        this.state.paged_content_element.innerHTML = '';
    },

    /**
     * Устанавливает фокус на последнем элементе архива
     */
    focusLastItem() {
        const lastLink = this.state.paged_content_element.querySelector('.group\\/card:last-child a');
        if (!lastLink) {
            console.debug('[archive-event] нет элемента для фокусировки');
            return;
        }

        lastLink.focus({
            preventScroll: true
        });
    },

    /**
     * Переключение видимости фильтров (мобильный экран)
     */
    toggleFilters() {
        this.state.show_filters     = !this.state.show_filters;
        this.state.calendar.is_open = false;
    },

    /**
     * Наличие активных фильтров
     * @return {number|0|boolean}
     */
    hasActiveFilters() {
        return this.filters.premiere
            || this.filters.pushkin_card
            || this.filters.in_stock
            || this.filters.sale
            || this.filters.event_types.length
            || (this.filters.age_limits.length && this.filters.age_limits[0] !== 'all')
    },

    /**
     * Сброс фильтров
     */
    resetFilters() {
        this.filters.premiere     = false;
        this.filters.pushkin_card = false;
        this.filters.in_stock     = false;
        this.filters.sale         = false;
        this.filters.event_types  = [];

        console.debug('[archive-event] фильтры сброшены');
    },

    /**
     * Переключение видимости календаря
     */
    toggleCalendar() {
        this.state.calendar.is_open = !this.state.calendar.is_open;
        this.state.show_filters     = false;
    },

    closeCalendar($event) {
        if ($event.target.getAttribute('id') === 'toggle-calendar-button') {
            return;
        }

        this.state.calendar.is_open = false;
    },

    navigateToEventWithDate(date) {
        console.debug('[archive-event] переход к элементу с датой', date);

        if (this.state.is_navigate_to_date_pending) {
            console.debug('[archive-event] переход к элементу с датой уже запланирован');
            return;
        }

        this.state.navigate_to_date            = date.toISOString().split('T')[0];
        this.state.is_navigate_to_date_pending = true;

        this.navigateToEventWithDateAttempt();
    },

    navigateToEventWithDateAttempt() {
        console.debug('navigateToEventWithDateAttempt', this.state.navigate_to_date);

        if (!this.state.navigate_to_date) {
            console.debug('navigateToEventWithDateAttempt skipped: navigate_to_date is not set');
            return;
        }

        if (this.state.is_front_page) {
            let searchParamsData = this.getSearchParamsData();

            delete searchParamsData.front;

            let urlSearchParams = new URLSearchParams(searchParamsData).toString();

            window.location.href = this.state.base_url + this.state.route + '?' + urlSearchParams + '#' + this.state.navigate_to_date;

            return;
        }

        let card = this.state.paged_content_element.querySelector(`[data-calendar-date="${this.state.navigate_to_date}"]`);

        if (!card) {
            console.debug('[archive-event] не найден элемент для выполнения прокрутки');

            let last_card = this.state.paged_content_element.querySelector(`[data-calendar-date]:last-child`);
            if (!last_card) {
                return;
            }

            last_card.scrollIntoView();
            return;
        }

        if (this.state.is_loading) {
            console.debug('navigateToEventWithDateAttempt skipped: loading in progress');
            return;
        }

        this.state.navigate_to_date = null;

        //card.scrollIntoView();

        let cardHeight = card.clientHeight;

        console.debug('navigateToEventWithDateAttempt cardHeight', cardHeight);

        const headerHeight = 80;

        let offset = (headerHeight / 2) + (window.innerHeight / 2) - (cardHeight / 2);

        console.debug('offset', offset);

        this.smoothScroll(card, -offset).then(() => {
            // Успешная прокрутка
        }).catch(() => {
            // Если прокрутка не удалась
        }).finally(() => {
            // Сброс ожидания
            this.state.is_navigate_to_date_pending = false;

            // Начало анимации
            setTimeout(() => {
                card.classList.add('md:scale-[1.05]');
            }, 500);

            // Конец анимации
            setTimeout(() => {
                card.classList.remove('md:scale-[1.05]');
            }, 1500);
        });
    },

    /**
     * https://stackoverflow.com/a/53247994/2453148
     */
    smoothScroll(elem, offset = 0) {
        const rect         = elem.getBoundingClientRect();
        let targetPosition = Math.floor(rect.top + self.pageYOffset + offset);
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });

        return new Promise((resolve, reject) => {
            const failed = setTimeout(() => {
                reject();
            }, 100);

            const scrollHandler = () => {
                if (self.pageYOffset === targetPosition) {
                    window.removeEventListener("scroll", scrollHandler);
                    clearTimeout(failed);
                    resolve();
                }
            };
            if (self.pageYOffset === targetPosition) {
                clearTimeout(failed);
                resolve();
            } else {
                window.addEventListener("scroll", scrollHandler);
                elem.getBoundingClientRect();
            }
        });
    },

    loadNextPageUntilNextMonth() {
        console.debug('[archive-event] loadNextPageUntilNextMonth');

        if (!this.state.has_next_page) {
            console.debug('[archive-event] нет следующей страницы');
            return;
        }

        let last_card = this.state.paged_content_element.querySelector('[data-calendar-date]:last-of-type')
        if (!last_card) {
            console.debug('[archive-event] карточка с атрибутом [data-calendar-date] не найдена.')
            return;
        }

        let last_card_dateYmd = last_card.getAttribute('data-calendar-date')
        if (!last_card_dateYmd.length) {
            return;
        }

        console.debug('[archive-event] дата последней карточки', last_card_dateYmd)

        let last_card_dateObj = new Date(last_card_dateYmd);
        if (last_card_dateObj.toString() === 'Invalid Date') {
            console.warn(`[archive-event] не удалось распознать дату карточки`)
            return;
        }

        const activeMonthDateYmd = this.state.calendar.active_month;

        const activeMonthDateObj = new Date(activeMonthDateYmd)

        if (activeMonthDateObj.getFullYear() !== last_card_dateObj.getFullYear()) {
            console.debug(`[archive-event] подгрузка страниц не требуется`);
            return;
        }

        if (activeMonthDateObj.getMonth() !== last_card_dateObj.getMonth()) {
            console.debug(`[archive-event] подгрузка страниц не требуется`);
            return;
        }

        console.debug(`[archive-event] подгрузка страниц текущего месяца…`);
        this.loadPage(this.state.page + 1, false, false);
    },

    /**
     * Установить активный месяц календаря
     */
    setActiveMonth(monthYmd) {
        this.state.calendar.active_month = monthYmd;
        console.debug('[archive-event] установлен активный месяц', monthYmd);
    },

    /**
     * Является ли месяц (строка Y-m-01) активным месяцем календаря?
     */
    isActiveCalendarMonth(monthYmd) {
        return this.state.calendar.active_month === monthYmd;
    },

    /**
     * Имеет ли месяц (строка Y-m-01) активные (отфильтрованные) события?
     */
    isMonthHasActiveEvents(monthYmd) {
        const monthDateObj = new Date(monthYmd);

        const datesOfMonth = this.getDatesOfMonth(monthDateObj)

        return datesOfMonth.some(dateObj => {
            return this.isCalendarDayHasActiveEvents(dateObj)
        });
    },

    /**
     * Дни месяца (массив дат)
     */
    getDatesOfMonth(date) {
        let month = date.getMonth();
        let days  = [];
        while (date.getMonth() === month) {
            days.push(new Date(date));
            date.setUTCDate(date.getUTCDate() + 1);
        }
        return days;
    },

    /**
     * Является ли дата сегодняшней
     */
    isCalendarDayToday(dateObj) {
        if (dateObj === null) {
            return false;
        }

        let dateYmd = dateObj.toISOString().split('T')[0];

        let todayYmd = this.state.calendar.today.toISOString().split('T')[0];

        return dateYmd === todayYmd;
    },

    /**
     * Содержит ли календарь активные (отфильтрованные) события
     */
    isCalendarDayHasActiveEvents(dateObj, checkFilters) {
        if (dateObj === null) {
            return false;
        }

        checkFilters = checkFilters ?? true;

        let dateYmd = dateObj.toISOString().split('T')[0];

        return this.state.available_events.some(event => {
            // Проверка даты
            if (event.date !== dateYmd) {
                return false;
            }

            // Не проверять фильтры?
            if (!checkFilters) {
                return true;
            }

            // Проверка фильтра «Премьера»
            if (this.filters.premiere) {
                if (!event.premiere) {
                    return false;
                }
            }

            // Проверка фильтра «Пушкинская карта»
            if (this.filters.pushkin_card) {
                if (!event.pushkin_card) {
                    return false;
                }
            }

            // Проверка фильтра «Есть билеты»
            if (this.filters.in_stock) {
                if (!event.in_stock) {
                    return false;
                }
            }

            // Проверка фильтра «Скидка»
            if (this.filters.sale) {
                if (!event.sale) {
                    return false;
                }
            }

            // Проверка фильтра «Жанр»
            if (this.filters.event_types.length) {
                if (!this.filters.event_types.includes(event.type)) {
                    return false;
                }
            }

            // Проверка фильтра «Возраст»
            if (!this.isEventUnderAgeLimitSelectedOption(event)) {
                return false;
            }

            // Если все проверки пройдены, то событие подходит
            return true;
        });
    },

    /**
     * Заблокирован ли фильтр «Премьера»?
     */
    isPremiereFilterDisabled() {
        // Не блокируем, если активно
        if (this.filters.premiere) {
            return false;
        }

        return !this.state.available_events.some(event => {
            // Проверка фильтра «Пушкинская карта»
            if (this.filters.pushkin_card) {
                if (!event.pushkin_card) {
                    return false;
                }
            }

            // Проверка фильтра «C билетами»
            if (this.filters.in_stock) {
                if (!event.in_stock) {
                    return false;
                }
            }

            // Проверка фильтра «Скидка»
            if (this.filters.sale) {
                if (!event.sale) {
                    return false;
                }
            }

            // Проверка фильтра «Жанр»
            if (this.filters.event_types.length) {
                if (!this.filters.event_types.includes(event.type)) {
                    return false;
                }
            }

            return event.premiere;
        });
    },

    /**
     * Заблокирован ли фильтр «Пушкинская карта»?
     */
    isPushkinCardFilterDisabled() {
        // Не блокируем, если активно
        if (this.filters.pushkin_card) {
            return false;
        }

        return !this.state.available_events.some(event => {

            // Проверка фильтра «Премьера»
            if (this.filters.premiere) {
                if (!event.premiere) {
                    return false;
                }
            }

            // Проверка фильтра «Есть билеты»
            if (this.filters.in_stock) {
                if (!event.in_stock) {
                    return false;
                }
            }

            // Проверка фильтра «Скидка»
            if (this.filters.sale) {
                if (!event.sale) {
                    return false;
                }
            }

            // Проверка фильтра «Жанр»
            if (this.filters.event_types.length) {
                if (!this.filters.event_types.includes(event.type)) {
                    return false;
                }
            }

            return event.pushkin_card;
        });
    },

    /**
     * Заблокирован ли фильтр «Есть билеты»?
     */
    isSaleFilterDisabled() {
        // Не блокируем, если активно
        if (this.filters.sale) {
            return false;
        }

        return !this.state.available_events.some(event => {

            // Проверка фильтра «Премьера»
            if (this.filters.premiere && !event.premiere) {
                return false;
            }

            // Проверка фильтра «Пушкинская карта»
            if (this.filters.pushkin_card && !event.pushkin_card) {
                return false;
            }

            // Проверка фильтра «Есть билеты»
            if (this.filters.in_stock && !event.in_stock) {
                return false;
            }

            // Проверка фильтра «Жанр»
            if (this.filters.event_types.length && !this.filters.event_types.includes(event.type)) {
                return false;
            }

            return event.sale;
        });
    },

    /**
     * Заблокирован ли фильтр «Скидка»?
     */
    isInStockFilterDisabled() {
        // Не блокируем, если активно
        if (this.filters.in_stock) {
            return false;
        }

        return !this.state.available_events.some(event => {
            // Проверка фильтра «Пушкинская карта»
            if (this.filters.pushkin_card) {
                if (!event.pushkin_card) {
                    return false;
                }
            }

            // Проверка фильтра «Премьера»
            if (this.filters.premiere) {
                if (!event.premiere) {
                    return false;
                }
            }

            // Проверка фильтра «Скидка»
            if (this.filters.sale) {
                if (!event.sale) {
                    return false;
                }
            }

            // Проверка фильтра «Жанр»
            if (this.filters.event_types.length) {
                if (!this.filters.event_types.includes(event.type)) {
                    return false;
                }
            }

            return event.in_stock;
        });
    },

    /**
     * Инициализация фильтра «Рекомендованный возраст»
     */
    initAgeLimitFilter(options) {
        if (!options?.length) {
            return;
        }

        this.age_limit_filter.options = options;

        //console.debug('initAgeLimitFilter опции', this.age_limit_filter.options);

        // noinspection JSUnresolvedReference
        this.$watch('filters', () => {

            this.age_limit_filter.active_options = this.getAgeLimitActiveOptions()
            this.age_limit_filter.filter_options = this.getAgeLimitFilterOptions()
        });

        this.age_limit_filter.active_options = this.getAgeLimitActiveOptions();
        this.age_limit_filter.filter_options = this.getAgeLimitFilterOptions();
    },

    /**
     * Инициализация фильтра «Жанр»
     */
    initEventTypeFilter(options) {
        if (!options?.length) {
            return;
        }

        this.event_type_filter.options = options.filter(option => {
            return this.state.available_events.some(event => event.type === option.value)
        });

        // noinspection JSUnresolvedReference
        this.$watch('filters', () => {

            this.event_type_filter.active_options = this.getEventTypeActiveOptions()
            this.event_type_filter.filter_options = this.getEventTypeFilterOptions()
        });

        this.event_type_filter.active_options = this.getEventTypeActiveOptions()
        this.event_type_filter.filter_options = this.getEventTypeFilterOptions()
    },

    /**
     * Список активных опций фильтра «Рекомендованный возраст»
     */
    getAgeLimitActiveOptions() {
        return this.age_limit_filter.options.filter(option => {
            return this.state.available_events.some(event => {
                // Проверка фильтра «Жанр»
                if (this.filters.event_types.length) {
                    if (!this.filters.event_types.includes(event.type)) {
                        return false;
                    }
                }

                if (option.value === 'all') {
                    return true
                }

                // noinspection JSUnresolvedReference
                if (event.age_limit_recommend < option.min) {
                    return false
                }

                // noinspection JSUnresolvedReference,RedundantIfStatementJS
                if (event.age_limit_recommend > option.max) {
                    return false
                }

                return true;
            })
        })
    },

    /**
     * Список активных опций фильтра «Жанр»
     */
    getEventTypeActiveOptions() {
        return this.event_type_filter.options.filter(option => {
            return this.state.available_events.some(event => {
                // Проверка даты
                let eventDate = new Date(event.date);
                let monthDate = new Date(this.state.calendar.active_month);
                eventDate.setDate(1);
                monthDate.setDate(1);
                if (eventDate < monthDate) {
                    return false;
                }

                // Проверка фильтра «Премьера»
                if (this.filters.premiere) {
                    if (!event.premiere) {
                        return false;
                    }
                }

                // Проверка фильтра «Пушкинская карта»
                if (this.filters.pushkin_card) {
                    if (!event.pushkin_card) {
                        return false;
                    }
                }

                // Проверка фильтра «Есть билеты»
                if (this.filters.in_stock) {
                    if (!event.in_stock) {
                        return false;
                    }
                }

                // Проверка фильтра «Скидка»
                if (this.filters.sale) {
                    if (!event.sale) {
                        return false;
                    }
                }

                // Проверка фильтра «Возраст»
                if (!this.isEventUnderAgeLimitSelectedOption(event)) {
                    return false;
                }

                return event.type === option.value;
            });
        });
    },

    /**
     * Проверка фильтра «Возраст»
     */
    isEventUnderAgeLimitSelectedOption(event) {
        if (!this.filters.age_limits[0]) {
            return true;
        }

        const filter_age_limit_value = this.filters.age_limits[0];

        const age_limit_option = this.age_limit_filter.options.find(option => {
            return option.value === filter_age_limit_value;
        })

        if (!age_limit_option) {
            console.warn('[archive-event] Опция возрастного ограничения не найдена', filter_age_limit_value);
            return false;
        }

        // noinspection JSUnresolvedReference
        if (event.age_limit_recommend < age_limit_option.min) {
            return false;
        }

        // noinspection JSUnresolvedReference,RedundantIfStatementJS
        if (event.age_limit_recommend > age_limit_option.max) {
            return false;
        }

        return true;
    },

    /**
     * Список опций для фильтра «Возрастное ограничение»
     */
    getAgeLimitFilterOptions() {
        return this.age_limit_filter.options.map(option => {
            const disabled = !this.age_limit_filter.active_options.some(active_option => {
                return active_option.value === option.value
            })

            return {...option, disabled};
        })
    },

    /**
     * Список опций для фильтра «Жанр»
     */
    getEventTypeFilterOptions() {
        return this.event_type_filter.options.map(option => {
            const disabled = !this.event_type_filter.active_options.some(active_option => {
                return active_option.value === option.value
            })

            return {...option, disabled};
        })
    },
});
